import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from 'shared/api/query-client';
import { logQueryErrorToConsole } from 'shared/api/query-errors';
import { configureApiClient } from 'shared/api/api-client';
import { REGIONS } from 'shared/constants/region.constants';
import authService from '@/lib/auth';
import App from './App';
import '../styles/globals.css';

// Back-office has no Redux store: cookie auth, region from login, own refresh.
configureApiClient({
  withCredentials: true,
  getRegion: () => authService.state.region ?? REGIONS.US,
  refresh: () => authService.refreshAccessToken(),
});

// Back-office has no Datadog or Sentry, so the console really is just the
// console here, and the app is staff-only — logging in every environment is
// what lets support see why a query failed.
const queryClient = createQueryClient({}, { onError: logQueryErrorToConsole });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
